module.exports = __webpack_public_path__ + "static/media/ga.4e5e8a64.svg";